import React from "react";
import Image from "../Products/Image";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {responsive3} from "../../utils/constant";

const SliderCol3 =({item, title})=>{
if(item && item.length > 0){
    return(
        <div className="breand__page">
            <div className="container m-auto p-0">
                <div className="row m-0 row--maint">
                    <div className="col-12 px-0">
                        <div className="maint__title">
                            <div className="row m-0">
                                <div className="maint__title--left col-12 px-0">
                                    <h2 className="float-start fw-bold ">{title}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 p-0 mt-2">
                        <div className="mant__item p-0">
                            <div className="row m-0 position-relative">
                            <Carousel key="Carouselbanner"
                            responsive = {responsive3}
                            showDots={false}
                            autoPlay={false}
                            autoPlaySpeed={3000}
                            infinite={true}
                            swipeable={true}
                            rewind={true}
                            >   
                                {
                                    item.map((item, i)=>{
                                        return <div key={i} className="breand__slider--content w-100">
                                                <a href={item.link}><Image imgTitle={item.name} url={item.images} className="h-100 w-100" style=""/></a>
                                            </div>
                                    })
                                }
                            </Carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}else{return null}
    
}
export default SliderCol3;